import React from 'react';
import { Modal, Button } from "antd";
import "./function-uninstall.scss";

import { Http } from '../../../../helpers/axois';
import { logger } from '../../../../constant/winston';
import { useToast } from '../../../../helpers/commonFunction';
import { useSelector } from 'react-redux';

import { ReactComponent as CloseIcon } from "../../../../assets/svg/roundedCloseIcon.svg";
import { AppState } from '../../../../stateManager/store';

interface IProps {
  visible: boolean;
  setVisible: (setVisible: boolean) => void;
  functionData: any;
  handleFunctionStatus:any;
}

export const FunctionUninstall: React.FC<IProps> = ({ visible, setVisible,functionData , handleFunctionStatus }) => {
  const { id, name } = functionData;
  const { SuccessToast, ErrorToast } = useToast();
  const org_id = useSelector((state: any) => state.org.selectedOrg.id)
  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
  const { selectedOrg } = useSelector((state: AppState) => state.org)
  const loggedInUserId = useSelector((state: any) => {
      return state.user.data.user.id
  })
  const handleWidgetUnInstall = async (e: { stopPropagation: () => void; }) => {
    e.stopPropagation();
    if ((!orgPermissions?.includes("marketplace.PublishApp") || !orgPermissions.includes('org.View')) && loggedInUserId!=selectedOrg?.owner) {
      ErrorToast("Not Authorized: Please request owner of this organization to provide access")
      return
    } 
    // delete("/orgs/:orgId/marketplaceFunctions/install/:functionId"
    const endpoint = `/orgs/${org_id}/marketplaceFunctions/install/${id}`
    Http.delete(endpoint).subscribe(() => {
      handleFunctionStatus(id, false)
      SuccessToast(`Uninstalled ${name}`);
    }, (err) => {
      if (err === "Forbidden") {
        ErrorToast("Not Authorized: Please request owner of this organization to provide access")
      } else {
        ErrorToast(err.message)
      }
      logger.error(err)
    })
    setVisible(false);
  }

  const handleOnCancel = () => {
    setVisible(false);
  };

  return (
    <Modal
      title="UNINSTALL"
      visible={visible}
      className="override-modal"
      style={{
        top: 200
      }}
      width="450px"
      closeIcon={
        <CloseIcon
          height="18px"
          width="18px"
          onClick={() => setVisible(false)}
        />
      }
      maskStyle={{
        background: "#0000001",
      }}
      footer={false}
    >
      <div className="delete-modal delete-modal-content">
        <p>
          Are you sure you want to Uninstall this <span>{name}?</span>
        </p>
      </div>
      <div className="delete-modal delete-modal-footer">
        <Button type="ghost" className="cancel" onClick={handleOnCancel}>
          Maybe next time
        </Button>
        <Button type="danger" className="ok" onClick={handleWidgetUnInstall}>
          Yes, Do it
        </Button>
      </div>
    </Modal>
  );
}
